import { default as React, useEffect, useState } from "react"
import { Row } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { useDispatch } from "react-redux"
import { RouteComponentProps } from "react-router"
import { Header } from "../../common/headers"
import SideBar from "../../common/layout/sidebar.component"
import IntlProps from "../../state/helpers/IntlProps"
import { InventoryLocationAction } from "../../state/inventory/location/actions"
import { EDIT_STOCK_LOCATION_PAGE_MESSAGES } from "../../utils/inventory"
import StockLocationForm from "../forms/StockLocationForm"

type Params = {
    stockLocationId:string
}
const EditStockLocationPage = (props: IntlProps & RouteComponentProps<Params>) => {
    const dispatch = useDispatch()
    const stockLocationId = props.match.params.stockLocationId
    const [renderFinish, setRenderFinish] = useState(false)
    useEffect(() => {
        dispatch(InventoryLocationAction.setFromListing(stockLocationId))
    }, [stockLocationId])

    useEffect(() => {
        SideBar.activateMenu("inventory")
        setRenderFinish(true)
    }, [])

    return (
        <div className="mb-4">
            <Row className="ui-has-modules">
                <div className="col-8">
                    <Header title={props.intl.formatMessage(EDIT_STOCK_LOCATION_PAGE_MESSAGES["mainLabel"])}/>
                </div>
            </Row>
            {renderFinish && <StockLocationForm/>}
        </div>
    )

}

export default injectIntl(EditStockLocationPage)


// WEBPACK FOOTER //
// ./src/inventory/pages/EditStockLocationPage.tsx